import { MouseEventHandler } from "react";
import styles from "./PlusButton.module.css"

type PlusButtonProps = {
    onClick: MouseEventHandler<HTMLButtonElement> | undefined;
}

export default function PlusButton({ onClick }: PlusButtonProps) {
    return(
        <button type="submit" onClick={onClick} className={styles.btn}>
            <img className={styles.img} src="/buttons/plus.png" alt="plus" />
        </button>
    )
}